import type { FC } from 'react';
import { cn } from '../lib/utils';
import { DataTypeIcon } from './data-type-icon';
import type { DataType } from './data-types';

interface DataTypeLabelProps {
  type: DataType;
  className?: string;
}

/** A field's type, glyph first: `# int`, `T string`, `▣ timestamp`. */
export const DataTypeLabel: FC<DataTypeLabelProps> = ({ type, className }) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center gap-1 text-[10px] text-muted-foreground',
      className
    )}
  >
    <DataTypeIcon type={type} />
    {type}
  </span>
);
